import { topics } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-800',
  primary: 'bg-primary-100 text-primary-800',
  secondary: 'bg-secondary-100 text-secondary-800',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
            热门话题标签
          </h2>
          <p className="text-sm text-foreground-500">全网最热的吃瓜话题都在这里，点击标签直达相关内容</p>
        </div>
        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topics.map((t) => (
            <a
              key={t.id}
              href="#topics"
              className={`inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full text-sm font-medium transition-all cursor-pointer hover:scale-105 ${
                colorMap[t.color] || 'bg-secondary-100 text-secondary-800'
              }`}
            >
              {t.tag && (
                <span
                  className={`inline-flex text-[10px] font-bold px-1.5 py-0.5 rounded ${
                    t.tag === '爆'
                      ? 'bg-accent-500 text-background-50'
                      : t.tag === '沸'
                        ? 'bg-accent-400 text-background-50'
                        : t.tag === '热'
                          ? 'bg-accent-200 text-accent-900'
                          : 'bg-primary-200 text-primary-900'
                  }`}
                >
                  {t.tag}
                </span>
              )}
              <span>{t.name}</span>
              <span className="text-xs opacity-60">{t.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}